import DOMPurify from 'dompurify';

const HTML_TAG_REGEX = /<[a-z][\s\S]*>/i;

export const isHtmlMessage = (text: string): boolean => HTML_TAG_REGEX.test(text);

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  's',
  'u',
  'mark',
  'ul',
  'ol',
  'li',
  'a',
  'code',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export const sanitizeMessageHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORCE_BODY: false,
  });

const STRIP_TAGS_REGEX = /<[^>]*>/g;

export const stripHtmlTags = (html: string): string => html.replace(STRIP_TAGS_REGEX, '').trim();

export const toRichTextParagraph = (text: string): string => {
  const escapedText = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  return `<p>${escapedText}</p>`;
};

export const HIGHLIGHT_COLOR = 'var(--color-yellow-200)';
